import { QueryParamConfig } from 'use-query-params';
import base64url from 'base64url';

export const createEncodedObjectParam = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  OriginalType extends string | any[],
  ResultType,
>() => {
  const queryParamConfig: QueryParamConfig<
    OriginalType,
    ResultType | undefined | null
  > = {
    encode(value) {
      if (!value) {
        return value;
      }

      const encoded = base64url.encode(JSON.stringify(value));
      return encoded;
    },
    decode(encodedValue) {
      if (!encodedValue) {
        return null;
      }

      if (Array.isArray(encodedValue)) {
        return encodedValue?.map((value) => {
          if (!value) {
            return null;
          }
          const decoded = base64url.decode(value);
          const asObject = JSON.parse(decoded);
          return asObject;
        });
      }

      const decoded = base64url.decode(encodedValue);
      const asObject = JSON.parse(decoded);
      return asObject;
    },
  };

  return queryParamConfig;
};
